import HttpRequest from '@/config/axios.config'
import {
  COMPANY_SETTING_HAS_DEFECT_AREA,
  COMPANY_SETTING_NAME_HIDE_ORDER_ACTIONS,
  COMPANY_SETTING_HAS_EXPORT_DATA,
  COMPANY_SETTING_NAME_HIDE_ORDER_PROPERTIES,
  COMPANY_SETTING_NAME_INSPECTION_TYPE,
  COMPANY_SETTING_NAME_ORDER_TYPE,
  COMPANY_SETTING_NAME_STRING_TYPE,
  COMPANY_SETTING_NAME_SUBMIT_FOR_REVIEW,
  COMPANY_SETTING_NAME_TIME_ACTION_TYPE,
  COMPANY_SETTING_ENABLE_ACTIVATION,
  COMPANY_SETTING_TYPE,
  COMPANY_SETTING_ORDER_ADVANCE_FILTER_CUSTOM,
  COMPANY_SETTING_AUTO_GENERATE_PROPERTY_VALUE,
  COMPANY_SETTING_FCCA_RATING,
  COMPANY_SETTING_PRODUCTION_STATUS,
  COMPANY_SETTING_OVERALL_RESULT,
  COMPANY_SETTING_SHOW_UUID,
  COMPANY_SETTING_HIDDEN_BLOCKS,
  COMPANY_SETTING_HAS_SUPPLIER,
  COMPANY_SETTING_AUDIT_RATING_TITLES,
  COMPANY_SETTING_PRODUCT_ADVANCE_FILTER_CUSTOM,
  COMPANY_SETTING_HAS_MEASUREMENT_AQL,
  COMPANY_SETTING_DEFECT_STATUS,
  COMPANY_SETTING_REPORT_COMBINED_DEFECTS,
  COMPANY_SETTING_LIVEBOARD_SETTING,
} from '@/constant/user'
import { isEmpty } from 'lodash'

export async function getUsersRef(payload) {
  return await HttpRequest.get('users/all', { params: payload })
}

export async function getRolesRef() {
  return await HttpRequest.get('role-accesses')
}

export async function updateRoleRef(payload: any) {
  // should add on payload status: active/inactive
  return await HttpRequest.put('users/role-access', payload)
}

export async function getCompanySettingRef(
  settingType?: COMPANY_SETTING_TYPE | '',
  settingName?:
    | COMPANY_SETTING_NAME_INSPECTION_TYPE
    | COMPANY_SETTING_NAME_TIME_ACTION_TYPE
    | COMPANY_SETTING_NAME_ORDER_TYPE
    | COMPANY_SETTING_NAME_STRING_TYPE
    | COMPANY_SETTING_HAS_DEFECT_AREA
    | typeof COMPANY_SETTING_ENABLE_ACTIVATION
    | typeof COMPANY_SETTING_NAME_HIDE_ORDER_PROPERTIES
    | typeof COMPANY_SETTING_NAME_SUBMIT_FOR_REVIEW
    | typeof COMPANY_SETTING_NAME_HIDE_ORDER_ACTIONS
    | typeof COMPANY_SETTING_AUTO_GENERATE_PROPERTY_VALUE
    | typeof COMPANY_SETTING_HAS_EXPORT_DATA
    | typeof COMPANY_SETTING_ORDER_ADVANCE_FILTER_CUSTOM
    | typeof COMPANY_SETTING_HIDDEN_BLOCKS
    | typeof COMPANY_SETTING_FCCA_RATING
    | typeof COMPANY_SETTING_PRODUCTION_STATUS
    | typeof COMPANY_SETTING_OVERALL_RESULT
    | typeof COMPANY_SETTING_SHOW_UUID
    | typeof COMPANY_SETTING_HAS_SUPPLIER
    | typeof COMPANY_SETTING_AUDIT_RATING_TITLES
    | typeof COMPANY_SETTING_DEFECT_STATUS
    | typeof COMPANY_SETTING_LIVEBOARD_SETTING
    | typeof COMPANY_SETTING_PRODUCT_ADVANCE_FILTER_CUSTOM
    | typeof COMPANY_SETTING_HAS_MEASUREMENT_AQL
    | typeof COMPANY_SETTING_REPORT_COMBINED_DEFECTS
    | ''
) {
  try {
    const queryName = isEmpty(settingName) ? '' : `&name=${settingName}`
    const queryType = isEmpty(settingType) ? '' : `&type=${settingType}`
    const statusActive = `&status=active`
    const queryParam = `${queryType}${queryName}${statusActive}`
    const { data } = await HttpRequest.get(`/company-settings?${queryParam}`)

    if (isEmpty(data.data)) {
      return []
    }

    return data.data
  } catch (error) {
    console.log('ERROR COMPANY SETTING', error)
    return []
  }
}

export async function getInspectorSetting() {
  try {
    const { data } = await HttpRequest.get(
      `/company-settings?type=inspection&status=active&name=has_inspector`
    )
    return data?.data[0]?.value?.status === true
  } catch (error) {
    console.log(error)
  }
}

export async function getSupplierCanCreateInspectionSetting() {
  try {
    const { data } = await HttpRequest.get(
      `/company-settings?type=inspection&status=active&name=supplier_can_create_inspection`
    )
    return data?.data[0]?.value?.status === true
  } catch (error) {
    console.log(error)
    return false
  }
}
